import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'

export default async function loader({ params }) {
  const ruleDetail = mercuryApi
    .get(`/pay-rules/packages/${params.packageId}`)
    .then((p) => {
      // get the specific rule we have routed to from the whole package
      return p.rules.find((rule) => rule.id === params.ruleId)
    })

  return defer({
    data: ruleDetail,
  })
}
